const ORDINAL_SUFFIXES: Record<number, string> = {
  1: "st",
  2: "nd",
  3: "rd",
};

const getOrdinalSuffix = (day: number): string => {
  if (day >= 11 && day <= 13) {
    return "th";
  }

  return ORDINAL_SUFFIXES[day % 10] ?? "th";
};

const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const formatOrdinalDate = (date: Date, includeYear = false): string => {
  const day = date.getDate();
  const month = date.toLocaleDateString("en-GB", { month: "long" });
  const formattedDay = `${day}${getOrdinalSuffix(day)} ${month}`;

  if (includeYear) {
    return `${formattedDay} ${date.getFullYear()}`;
  }

  return formattedDay;
};

export const getTrustlyBillingDates = (trustlyBonusDays: number, interval = "month") => {
  const today = new Date();
  const paidSubscriptionStart = addDays(today, trustlyBonusDays);
  const directDebitStart = new Date(paidSubscriptionStart);
  directDebitStart.setDate(1);
  directDebitStart.setMonth(directDebitStart.getMonth() + 1);

  if (interval === "year") {
    directDebitStart.setFullYear(directDebitStart.getFullYear() + 1);
  }

  return {
    paidSubscriptionStartFormatted: formatOrdinalDate(paidSubscriptionStart),
    directDebitStartFormatted: formatOrdinalDate(directDebitStart, true),
    membershipMonth: paidSubscriptionStart.toLocaleDateString("en-GB", { month: "long" }),
  };
};

export const formatSubscriptionPrice = (unitAmount: number, interval: string): string => {
  const price = `£${unitAmount / 100}`;

  if (interval === "year") {
    return `${price}/year`;
  }

  return `${price}/month`;
};

export const formatTrustlyBonusDays = (bonusDays: number) => {
  if (bonusDays === 1) {
    return "TODAY as";
  }
  return `${bonusDays} days`;
};
